import React from "react";
import { Box } from "@mui/material";
import HeroSection from "./Sections/heroSection";
import FeaturesSection from "./Sections/featuresSection";
import HowItWorksSection from "./Sections/howItWorksSection";
import AudienceSection from "./Sections/audienceSection";

export const Landing = () => {
  return (
    <Box>
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <AudienceSection />
    </Box>
  );
};

export default Landing;
